import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyD_x00zy3JFo6CIHPPZkS03alVL9RczAvM",
    authDomain: "alpersan-manager.firebaseapp.com",
    projectId: "alpersan-manager",
    storageBucket: "alpersan-manager.appspot.com",
    messagingSenderId: "734401863414",
    appId: "1:734401863414:web:de663a21742977d85216d7"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const firestoreInst = firebase.firestore()
const authInst = firebase.auth()
const storageInst = firebase.storage()

// timestamp
const timestamp = firebase.firestore.Timestamp

export { firestoreInst, authInst, storageInst, timestamp }